import axios from 'axios'

const PostRequest = (url, data, header = null) => {
    const  baseUrl = 'https://earsiv-api.faveraportal.com'
    axios.defaults.withCredentials = true;
    const request = axios.post(`${baseUrl}/${url}`, data, header)

  return request;
};

export default PostRequest;
